
import { Box, Stack } from "@mui/material";
import { DischargeSection } from "./components/DischargeSection";
import { MedicalHistorySection } from "./components/MedicalHistorySection";

//YATAY;452641;18042025
function PageTwo() {
  return (
    <Box sx={{ p: 2 }}>
      <Stack spacing={4}>
        <DischargeSection />
        <MedicalHistorySection />
      </Stack>
    </Box>
  );
}

export default PageTwo;
